import React from 'react';
import 'twin.macro';
import H1 from '@teetsh/app/src/components/Typography/Headings/H1';
import { EditableTitle } from './EditableTitle';
import { h1Style } from '@teetsh/app/src/components/Typography/Headings/styles';

interface Props {
  hideTitle?: boolean;
  editableTitle?: boolean;
  programmationName?: string;
  children?: React.ReactNode;
}

export function ProgrammationWrapper({
  hideTitle,
  editableTitle,
  programmationName,
  children,
}: Props) {
  return (
    <div id="programmation">
      {!hideTitle && !editableTitle && (
        <H1 tw="text-center mb-6 print:break-after-avoid">
          {programmationName}
        </H1>
      )}
      {!hideTitle && editableTitle && (
        <div tw="flex justify-center mb-6 print:break-after-avoid">
          <EditableTitle css={h1Style} value={programmationName} />
        </div>
      )}
      <div tw="space-y-12">{children}</div>
    </div>
  );
}
